import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Link from 'components/Link';
import { bindGa } from 'helpers/analytics';
import { getSiteDomain } from 'utils/common';
import makeRequest from 'utils/makeRequest';
import { ENT_SEARCH_API } from 'constants/index';
import s from './Search.scss';
import subscribe_cookie from '../,,/../../../common/EducationWidget/helper';
import { loadVideosearchDataCount } from '../../../../reduxUtils/modules/videosearch';
import { loadtopvideos } from '../../../../reduxUtils/modules/topvideos';

class Search extends React.Component {
  getHighlightedResults(resultText) {
    const { searchedValue } = this.state;
    const searchedValueFirstIndex = resultText
      .toLowerCase()
      .indexOf(searchedValue.toLowerCase());
    return (
      <React.Fragment>
        {resultText.substring(0, searchedValueFirstIndex)}
        {
          <span className={s.resultSearchString}>
            {resultText.substring(
              searchedValueFirstIndex,
              searchedValueFirstIndex + searchedValue.length,
            )}
          </span>
        }
        {resultText.substring(
          searchedValueFirstIndex + searchedValue.length,
          resultText.length,
        )}
      </React.Fragment>
    );
  }

  renderResultItem(item, index) {
    const { highlightSearchedWordInResult } = this.props;
    const resultLink = item.link;
    const resultText = item.text || '';
    const selectedCss = '';
    return (
      <li key={index} className={s[selectedCss]}>
        <Link
          data-newga={`NavBar-Search#Search_Initiate | ${index || ''}`}
          to={resultLink}
        >
          {highlightSearchedWordInResult
            ? this.getHighlightedResults(resultText)
            : resultText}
        </Link>
      </li>
    );
  }

  static getItemLink(resultItem) {
    if (!(resultItem && resultItem instanceof Array && resultItem[0])) {
      return '';
    }
    const domain = getSiteDomain();
    const resultLink = `${domain}/topic/${resultItem[0]}`;
    return resultLink;
  }
  constructor(props) {
    super(props);
    this.state = {
      shouldShowSearchBox: false,
      searchResults: [],
    };
  }

  onKeyDown(event) {
    /*
			up = 38
			down = 40
			27 = escape
		*/
    /*
			ToDo - Add Debounce
		*/
    const keyCode = event.keyCode || event.which;
    if (keyCode === 40 || keyCode === 38) {
      this.markSelectedItem(keyCode);
    } else if (keyCode === 27) {
      this.setState({
        shouldShowSearchBox: false,
      });
    }
  }

  @bindGa({})
  onClick() {
    if (this.state.shouldShowSearchBox && this.searchField) {
      this.searchField.blur();
    }
    this.setState(
      {
        shouldShowSearchBox: !this.state.shouldShowSearchBox,
        searchedValue: '',
      },
      () => {
        if (this.searchField && this.state.shouldShowSearchBox) {
          this.searchField.focus();
        } else {
          this.searchField.blur();
          this.setState({
            searchResults: [],
          });
        }
      },
    );

    this.searchField.value = '';
  }

  markSelectedItem() {
    const results = Object.assign([], this.state.searchResults);
    const selected = results.filter(item => item.isSelected);
    let indexToHighlight;
    if (!selected.length) {
      indexToHighlight = 0;
    } else {
      const currentHighlightedIndex = results.indexOf(selected[0]);
      if (currentHighlightedIndex === results.length - 1) {
        indexToHighlight = 0;
      } else {
        results[currentHighlightedIndex + 1].isSelected = true;
      }

      results[indexToHighlight].isSelected = true;
      results[currentHighlightedIndex].isSelected = false;
    }

    this.setState({
      searchResults: results,
    });
  }

  fetchSearchResults = event => {
    const cityName = subscribe_cookie.get_cookie('geolocation');
    const apiDetails = `${ENT_SEARCH_API}${cityName}&feedtype=sjson&query=`;
    let searchKeyword = event.target.value || '';
    this.setState({
      searchedValue: searchKeyword,
    });
    searchKeyword = searchKeyword.trim();

    const url = `${apiDetails}${searchKeyword}`;
    makeRequest
      .get(url, {}, 'skipfeedengine')
      .catch(err => console.log(err))
      .then(data => {
        if (data && data.status === 200 && data.data && data.data.length > 0) {
          this.setState({
            searchResults: [],
          });
          this.setState({
            searchResults: data.data,
          });
        }
      });
  };

  renderSearchResults(data) {
    if (!(data && data instanceof Array)) {
      return null;
    }

    return (
      <div className={s.searchresultouter}>
        <div className="contentwrapper small rel">
          <div className={s.searchtopresultbox}>
            {data.map(item => {
              if (item.items && item.items.length) {
                return this.getCategoryResult(item);
              }
              return null;
            })}
          </div>
          {this.state.searchedValue &&
            this.state.searchedValue.length > 0 && (
              <div className={s.seeallresultlink}>
                See All Results Matching{' '}
                <span> {`  ${this.state.searchedValue}`}</span>
              </div>
            )}
        </div>
      </div>
    );
  }

  getCategoryResult(item) {
    return (
      <div className={s.searchresultboxouter}>
        <h4>{item.name}</h4>
        <ul className={s.nav_autosuggest_result}>
          {item.items.map((itemobj, index) =>
            this.renderResultItem(itemobj, index),
          )}
        </ul>
      </div>
    );
  }

  onFormSubmitVideos(event) {
    event.preventDefault();
    this.setState({
      shouldShowSearchBox: false,
    });
    const obj = {
      searchitem: this.searchField.value,
      isWapView: this.props.isWapView,
    };
    this.props.loadVideosearchDataCount(obj);
    this.props.loadtopvideos(this.props.isWapView);
    return false;
  }

  @bindGa({})
  onFormSubmit(event) {
    event.preventDefault();
    const resultLink = Search.getItemLink(this.state.searchResults[0]);
    if (resultLink) {
      window.location.href = resultLink;
    }
    return false;
  }

  render() {
    const { sticky } = this.props;
    const searchWrapperActiveClasses = this.state.shouldShowSearchBox
      ? 'active'
      : '';
    const gaLabelForSearchIcon = this.state.shouldShowSearchBox
      ? 'Search-Close'
      : 'Search-Click';
    const gaLabelForSearchKeyword =
      this.state.searchResults && this.state.searchResults.length > 0
        ? this.state.searchResults[0][0]
        : '';
    return (
      <div
        className={classNames({
          [`${s['search-form']}`]: true,
          [`${s[this.props.theme]}`]: this.props.theme,
          [`${s[searchWrapperActiveClasses]}`]: true,
          [`${s.sticky}`]: sticky,
          // [`${s[this.props.colorTheme]}`]: this.props.colorTheme,
        })}
      >
        <div className={s.searchoverlay} />
        <div className="contentwrapper small rel">
          <span
            onClick={event => this.onClick(event)}
            className={`${s['search-btn']}`}
            data-newga={`NavBar-Search#${gaLabelForSearchIcon}`}
          />
          <div
            className={`${s.inner} ${
              !this.state.shouldShowSearchBox ? s.hideSearchBox : ''
            }`}
          >
            <form
              data-plugin="navsearchboxvalidate"
              name="frmsearch1"
              onSubmit={event => {
                if (
                  window.location.href.indexOf('/videos') > 0 &&
                  !this.props.isWapView
                ) {
                  this.onFormSubmitVideos(event);
                } else {
                  this.onFormSubmit(event);
                }
              }}
              data-newga={`NavBar-Search#Search-Initiate-${gaLabelForSearchKeyword}`}
            >
              <input
                ref={el => {
                  if (el) {
                    this.searchField = el;
                  }
                }}
                onKeyDown={event => this.onKeyDown(event)}
                onChange={event => this.fetchSearchResults(event)}
                tabIndex="1"
                autoFocus="autoFocus"
                id="searchField"
                autoComplete="off"
                name="query"
                className="textbox"
                type="text"
                placeholder="Search for Movies, Theaters, Celebs, Web Series, Authors"
              />
              <input value="search" className="submit" type="submit" />
              <input type="hidden" value="" name="type" />
              <input type="hidden" value="233446897" name="catkey" />
              <input type="hidden" value="3" name="search" />
              <input type="hidden" value="" name="sitesearch" />
              <input type="hidden" value="1" name="fields" />
              <input type="hidden" value="2" name="searchtype" />
              <input type="hidden" value="2" name="article" />
              <input value="0" type="hidden" name="search1" />
              {/* <br className="clearfix"/> */}
            </form>
          </div>
        </div>
        {this.state.searchResults &&
          this.renderSearchResults(this.state.searchResults)}
      </div>
    );
  }
}

Search.propTypes = {
  theme: PropTypes.string,
  loadVideosearchDataCount: PropTypes.func.isRequired,
  // colorTheme: PropTypes.string,
  isWapView: PropTypes.bool.isRequired,
  loadtopvideos: PropTypes.func.isRequired,
  highlightSearchedWordInResult: PropTypes.bool,
  sticky: PropTypes.bool,
};

Search.defaultProps = {
  theme: undefined,
  sticky: false,
  highlightSearchedWordInResult: false,
};
const mapDispatchtoProps = dispatch => ({
  loadVideosearchDataCount: params => {
    dispatch(loadVideosearchDataCount(params));
  },
  loadtopvideos: isWapView => {
    dispatch(loadtopvideos(isWapView));
  },
});
export default connect(undefined, mapDispatchtoProps)(Search);
